import './stage.scss';
import { A11y, Mousewheel, Pagination } from 'swiper/modules';

class Stage {
    constructor ($element, options) {
        const defaults = {
            initAttr: 'data-stage'
        };

        this.settings = Object.assign({}, defaults, options);
        this.$stage = $element;
        this.$stageSlider = this.$stage.querySelector('[' + this.settings.initAttr + '="slider"]');
        this.$stageSlides = this.$stage.querySelectorAll('[' + this.settings.initAttr + '="slide"]');
        this.stageSlider = null;

        this.sliderActive = false;

        this.eventScroller = window.eventScroller;

        if (this.$stageSlides.length > 1) {
            import(
                /* webpackChunkName: "slider/slider.js" */
                '../../components/slider/slider').then(({ Slider }) => {
                this.Slider = Slider;
                this.initialize();
            });
        }
        // this.initialize();
    }

    initialize () {
        this.initSlider();
    }

    initSlider () {
        this.stageSlider = new this.Slider(this.$stageSlider, {
            modules: [A11y, Mousewheel, Pagination],
            direction: 'vertical',
            speed: 1000,
            slidesPerView: 'auto',
            slidesPerGroup: 1,
            autoHeight: true,
            calculateHeight: true,
            centeredSlides: false,
            centeredSlidesBounds: false,
            initialSlide: 0,
            initAttr: this.settings.initAttr,
            centerInsufficientSlides: true,
            touchReleaseOnEdges: true,
            mousewheel: {
                enabled: true,
                releaseOnEdges: true
            },
            indicators: true,
            prevnext: false,
            onSlideStart: ($slider, slider, $current) => {
                this.$stageSlider.classList.remove('show--animation');

                const hasClassName = $current.className.indexOf('is--') !== -1;
                if (hasClassName === true) {
                    this.$stageSlider.classList.remove('is--colored');
                } else {
                    this.$stageSlider.classList.add('is--colored');
                }
            },
            onInit: (swiper) => {
                // Force starting at first slide after any internal centering adjustments
                if (swiper && swiper.activeIndex !== 0) {
                    swiper.slideTo(0, 0);
                }
                this.$stageSlider.classList.add('show--animation');
            }
        });

        this.sliderActive = true;
    }
}

export { Stage };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $stage = $context.querySelector('[data-stage="root"]');
        if ($stage) {
            const stageAPI = new Stage($stage);
            $stage.API = stageAPI;
        }
    }
});
